import MuiSelect, { SelectProps } from '@mui/material/Select';
import FormControl from "../FormControl";
import FormHelperText from "../FormHelperText";
import InputLabel from "../InputLabel";

export type ISelectProps<T> = SelectProps<any> & {
  helperText?: string;
  id: string;
}
const Select = <T = number>(props: ISelectProps<T>): JSX.Element => {
  return (
    <FormControl error={props.error} fullWidth size="small" sx={props.sx}>
      <InputLabel shrink={true} id={"label" + props.id} >{props.label}</InputLabel>
      <MuiSelect
        {...props}
        labelId={"label" + props.id}
      />
      <FormHelperText error={props.error}>{props.helperText}</FormHelperText>
    </FormControl>
  )
};

export default Select;
